module.exports = __webpack_public_path__ + "img/fallback-slide-notext.3840x2160.71af2eaf.png";